import * as angular from "angular";
import * as _ from "lodash";

import {IController, ITimeoutService} from "angular";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {RoutePanelModel} from "../../models/route-panel.model";
import {Service} from "../../../deliveries/models/service.model";
import {
  RoutesViewSettingsModel,
  RoutesViewSettingsResourcesModel,
  RoutesViewSettingsServicesModel
} from "../../models/routes-view-settings.model";
import {ServiceStatusType} from "../../../deliveries/types/service-status.type";
import {
  ResourceAllocationTimeWindowExtModel
} from "../../../resources/models/resource-allocation-time-window-ext.model";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {tap} from "rxjs/operators";
import {ResourcesHttpService} from "../../../resources/angular/services/resources-http.service";
import {SortType} from "../../../commons/types/sort.type";
import {TagType} from "../../../tags/angular/types/tag.type";
import {RoutesViewMode} from "../../enums/routes-view-mode.enum";

export class RoutesViewResourcesPanelComponent implements IController {

  public RoutesViewMode = RoutesViewMode;

  index: number;
  panel: RoutePanelModel;
  viewMode: string;
  panels: RoutePanelModel[];
  resourcesDropListIds?: string[];
  routesDropListIds?: string[];
  selectedIds: string[];
  selectedServiceIds: string[];
  selectedResourceId?: string;
  settings: RoutesViewSettingsModel;
  visibleIds: string[];
  onResourcesDropListIdsChange: Function;
  onAddServicesToResource: Function;
  onChangeResourceSequence: Function;
  onUpdateRouteResource: Function;
  onDrillDownRoute: Function;
  onChangeRouteInfo: Function;
  onSettingsChange: Function;
  onPanelChange: Function;
  onToggleVisibleRoute: Function;

  public customTemplates: any;
  public selectedResource: ResourceAllocationTimeWindowExtModel;
  public sortOptions: string[] = [
    'routesCount',
    'resourceName',
    'startTime'
  ];

  /* @ngInject */
  constructor(
    private $timeout: ITimeoutService,
    private resizeService: ResizeService,
    private resourcesHttpService: ResourcesHttpService,
    private dateRangeTimeFiltersService: DateRangeTimeFiltersService
  ) {
    this.customTemplates = this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates();
  }

  $onInit() {
    const filtersInitialization = {
      includeFilters: [
        SiteFiltersType.dateRangeTemplateType,
        SiteFiltersType.branchIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.tags,
        SiteFiltersType.vehicleTypeIds,
        SiteFiltersType.inRoute
      ],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: undefined,
        [SiteFiltersType.branchIds]: [],
        [SiteFiltersType.serviceAreaIds]: [],
        [SiteFiltersType.tags]: [],
        [SiteFiltersType.vehicleTypeIds]: [],
        [SiteFiltersType.inRoute]: _.get(this.panel.resourcesFilters?.bringozFilters, SiteFiltersType.inRoute)
      },
      queryMap: {
        tagType: TagType.Resource
      },
      range: this.panel.resourcesFilters?.range || this.dateRangeTimeFiltersService.today(),
      queryString: undefined
    };

    if (
      !this.panel.resourcesFilters ||
      !this.panel.resourcesFilters.queryMap ||
      _.isEmpty(this.panel.resourcesFilters) ||
      this.panel.resourcesFilters?.includeFilters?.length !== filtersInitialization.includeFilters.length
    ) {
      this.panel.resourcesFilters = filtersInitialization;
    }

  }

  $onChanges(changes: angular.IOnChangesObject) {
    // if (changes.jobs && !changes.jobs.isFirstChange()) {
    //   if (this.jobs) {
    //     this._setFilteredJobs();
    //   }
    // }

    if (changes.selectedResourceId) {
      if (this.selectedResourceId) {
        if (this.selectedResource?.id !== this.selectedResourceId) {
          this._getSelectedResource();
        }
      } else {
        this.selectedResource = undefined;
      }
    }
  }

  private _getSelectedResource() {
    return this.resourcesHttpService.getResources({ids: [this.selectedResourceId]}).subscribe((response) => {
      this.onResourceSelect(response.list[0])
    })
  }


  onQueryChanged(query) {
    this.panel.resourcesFilters.queryString = query;
    this.onPanelChange({panel: this.panel});
  }

  onRangeChanged(range) {
    const dateRangeTemplate = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type);

    // Set Range
    this.panel.resourcesFilters.range = dateRangeTemplate || range;

    // Set Services Range
    if (this.panel.servicesFilters) {
      this.panel.servicesFilters.range = dateRangeTemplate || range;
    }

    // Set Also Resources Range
    if (this.panel.resourcesFilters) {
      this.panel.resourcesFilters.range = dateRangeTemplate || range;
    }

    this.onPanelChange({panel: this.panel});
  }

  onFiltersChange(filters) {
    _.forOwn(filters, (value, key) => {
      if (!_.isEqual(this.panel.resourcesFilters.bringozFilters[key], value)) {
        if (value === undefined || value === null) {
          _.unset(this.panel.resourcesFilters.bringozFilters, key);
        } else {
          this.panel.resourcesFilters.bringozFilters[key] = value;
        }
      }
    })

    this.panel.resourcesFilters.bringozFilters = angular.copy(this.panel.resourcesFilters.bringozFilters);
    this.onPanelChange({panel: this.panel});
  }

  onResourceSelect(resource?: ResourceAllocationTimeWindowExtModel) {
    this.selectedResource = resource;
    this.panel.selectedResourceId = resource?.id;

    this.onPanelChange({panel: this.panel});
    this.$timeout(100).then(() => {
      this.resizeService.resize();
    })
  }

  handleSortingChange(sortBy: string, sortType: SortType) {
    const panelCopy = angular.copy(this.panel);
    panelCopy.resourcesFilters.sortBy = sortBy;
    panelCopy.resourcesFilters.sortType = sortType;
    this.onPanelChange({panel: panelCopy});
  }

  onResourcesSettingsChange(resourcesSettings: RoutesViewSettingsResourcesModel) {
    const settings = angular.copy(this.settings);
    settings.resources = resourcesSettings;
    this.onSettingsChange({settings: settings});
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routesViewResourcesPanel', {
    bindings: {
      index: '<',
      panel: '<',
      viewMode: '<',
      panels: '<',
      resourcesDropListIds: '<?',
      routesDropListIds: '<?',
      selectedIds: '<',
      selectedServiceIds: '<',
      selectedResourceId: '<',
      settings: '<',
      visibleIds: '<',
      onClose: '&?',
      onFloat: '&?',
      onMinimize: '&?',
      onResourcesDropListIdsChange: '&',
      onAddServicesToResource: '&',
      onChangeResourceSequence: '&',
      onUpdateRouteResource: '&',
      onDrillDownRoute: '&',
      onChangeRouteInfo: '&',
      onSettingsChange: '&',
      onPanelChange: '&',
      onToggleVisibleRoute: '&'
    },
    template: require('./routes-view-resources-panel.html').default,
    controller: RoutesViewResourcesPanelComponent
  });
